import { z } from 'zod';
import { DISPLAY_NAME_MAX, PASSWORD_MIN } from '../constants.js';
import { createUserSchema } from './playerSchema.js';
export const rolleSchema = z.enum(['mitglied', 'admin']);
/** Kennung einer Umgebung: kurzer Slug, wie er in der Adresse steht. */
export const umgebungIdSchema = z.string().regex(/^[a-z0-9-]{2,32}$/, 'Nur Kleinbuchstaben, Ziffern und -');
/** Umgebungs-Admin legt ein Konto in seiner Umgebung an. */
export const createMitgliedUserSchema = createUserSchema.extend({
    rolle: rolleSchema.default('mitglied'),
});
/** Rolle eines Mitglieds setzen bzw. (Superadmin) ein bestehendes Konto zuweisen. */
export const setRolleSchema = z.object({ rolle: rolleSchema });
const kontoFelder = {
    displayName: z.string().trim().min(1).max(DISPLAY_NAME_MAX).optional(),
    password: z.string().min(PASSWORD_MIN).max(256).optional(),
    isActive: z.boolean().optional(),
};
const mindestensEinFeld = (v) => Object.keys(v).length > 0;
/** Konto-Felder, die ein Umgebungs-Admin aendern darf. */
export const updateMitgliedSchema = z
    .object(kontoFelder)
    .refine(mindestensEinFeld, 'Mindestens ein Feld erforderlich');
/** Superadmin legt ein Konto an, wahlweise direkt als Mitglied einer Umgebung. */
export const superadminCreateUserSchema = createUserSchema.extend({
    isSuperadmin: z.boolean().default(false),
    umgebungId: umgebungIdSchema.optional(),
    rolle: rolleSchema.default('mitglied'),
});
export const superadminUpdateUserSchema = z
    .object({ ...kontoFelder, isSuperadmin: z.boolean().optional() })
    .refine(mindestensEinFeld, 'Mindestens ein Feld erforderlich');
//# sourceMappingURL=umgebungSchema.js.map